<script>
import CommonMixin from './CommonMixin';
import LauncherOutlet from '@/launcher/components/routes/VR/outlet/LauncherOutlet.vue';

export default {
  name: 'GamesIndexRoute',
  mixins: [CommonMixin],
  components: {
    LauncherOutlet,
  },
};
</script>

<template lang="pug">
GamesBoxConnected.box
</template>

<style scoped>

</style>
